import { render } from "./fp_history.vue?vue&type=template&id=60d97568&scoped=true"
import script from "./fp_history.vue?vue&type=script&lang=js"
export * from "./fp_history.vue?vue&type=script&lang=js"

import "./fp_history.vue?vue&type=style&index=0&id=60d97568&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60d97568"]])

export default __exports__